/* Savage Gear — agregar al carrito sin recargar, y cajón lateral.
   Toda la animación vive en CSS; aquí solo se conmutan atributos y se pide
   el HTML del cajón a Shopify. */

(() => {
  'use strict';

  // En /cart se renderizan la sección de la página y el cajón del layout, y
  // ambas piden este archivo: dos <script src> idénticos se ejecutan las dos
  // veces. Sin este cerrojo habría dos juegos de escuchas delegadas y un clic
  // en "Quitar" borraría dos líneas, porque cada copia lleva su propio
  // indicador de "ocupado" y ninguna ve a la otra.
  if (window.__sgCarritoIniciado) return;
  window.__sgCarritoIniciado = true;

  const $ = (s, r = document) => r.querySelector(s);
  const $$ = (s, r = document) => [...r.querySelectorAll(s)];

  const cajon = () => $('[data-sg-cart]');
  const velo = () => $('[data-sg-cart-overlay]');

  let ultimoFoco = null;

  /* ---------------------------------------------------------------------- */
  /* Cajón                                                                   */
  /* ---------------------------------------------------------------------- */

  function abrir() {
    const c = cajon();
    if (!c) return;
    ultimoFoco = document.activeElement;
    c.dataset.open = 'true';
    velo() && (velo().dataset.open = 'true');
    c.removeAttribute('aria-hidden');
    document.body.style.overflow = 'hidden';
    const primero = c.querySelector('button, a[href], input');
    primero && primero.focus();
  }

  function cerrar() {
    const c = cajon();
    if (!c) return;
    c.dataset.open = 'false';
    velo() && (velo().dataset.open = 'false');
    c.setAttribute('aria-hidden', 'true');
    document.body.style.overflow = '';
    ultimoFoco && ultimoFoco.focus();
  }

  /* ---------------------------------------------------------------------- */
  /* Estado del carrito                                                      */
  /* ---------------------------------------------------------------------- */

  async function refrescar() {
    const enPagina = $('[data-sg-cart-page]');

    // Dos caminos según dónde estemos.
    //
    // Fuera de /cart basta la API de renderizado de secciones: el cajón vive en
    // el layout, así que se puede pedir sobre cualquier ruta y sale barato.
    //
    // En /cart se pide la página entera. La API de secciones no resuelve la
    // clave de una sección declarada en una plantilla JSON (devuelve null), y
    // pedirla por nombre de archivo la renderiza con los valores por defecto
    // del schema en vez de los que el cliente haya guardado en el editor. La
    // página completa trae además el cajón, que está en el layout: un solo
    // viaje deja las dos cosas al día y sin dos verdades posibles.
    const url = enPagina
      ? new URL(window.Shopify.routes.root + 'cart', window.location.origin)
      : (() => {
          const u = new URL(window.location.pathname, window.location.origin);
          u.searchParams.set('sections', 'sg-cart-drawer');
          return u;
        })();

    const r = await fetch(url);
    let doc;

    if (enPagina) {
      doc = new DOMParser().parseFromString(await r.text(), 'text/html');
      const nuevaPag = doc.querySelector('[data-sg-cart-page]');
      if (nuevaPag) enPagina.innerHTML = nuevaPag.innerHTML;
    } else {
      const data = await r.json();
      doc = new DOMParser().parseFromString(data['sg-cart-drawer'] || '', 'text/html');
    }

    const nuevo = doc.querySelector('[data-sg-cart-inner]');
    const actual = $('[data-sg-cart-inner]');
    if (nuevo && actual) actual.innerHTML = nuevo.innerHTML;

    const cuenta = doc.querySelector('[data-sg-cart-count]');
    $$('[data-sg-cart-count]').forEach((el) => {
      if (!cuenta) return;
      el.textContent = cuenta.textContent;
      el.hidden = cuenta.textContent.trim() === '0';
    });
  }

  /* ---------------------------------------------------------------------- */
  /* Agregar                                                                 */
  /* ---------------------------------------------------------------------- */

  async function agregar(form) {
    // El botón puede vivir fuera de su form (atributo form=): pasa en
    // "Combínalo con" de la página de carrito, que está dentro del form a /cart.
    // getAttribute y no form.id: el form tiene un input name="id" (la
    // variante) y form.id devuelve ese input.
    const idForm = form.getAttribute('id');
    const boton =
      form.querySelector('button[type="submit"]') ||
      (idForm && document.querySelector(`button[form="${idForm}"]`));
    if (!boton || boton.dataset.estado !== 'idle') return;

    boton.dataset.estado = 'cargando';
    try {
      const r = await fetch(`${window.Shopify.routes.root}cart/add.js`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({
          items: [{ id: form.querySelector('[name="id"]').value, quantity: 1 }],
        }),
      });
      if (!r.ok) throw new Error(await r.text());

      boton.dataset.estado = 'listo';
      await refrescar();
      abrir();
      aplicarClub();
      // Vuelve a "Agregar" para que se pueda sumar otra unidad sin recargar
      setTimeout(() => (boton.dataset.estado = 'idle'), 1800);
    } catch (e) {
      boton.dataset.estado = 'idle';
      // Si algo falla, el formulario nativo sigue funcionando: el cliente
      // nunca se queda sin poder comprar por un fallo de JS.
      form.removeAttribute('data-sg-add');
      form.submit();
    }
  }

  /* ---------------------------------------------------------------------- */
  /* Club Savage: consentimiento y códigos de miembro                        */
  /* ---------------------------------------------------------------------- */

  async function actualizar(cuerpo) {
    const r = await fetch(`${window.Shopify.routes.root}cart/update.js`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(cuerpo),
    });
    if (!r.ok) throw new Error(await r.text());
    return r.json();
  }

  // La casilla y el teléfono se guardan como atributos del carrito, que viajan
  // al pedido y de ahí a Shopify Flow (etiqueta `club` + correo de bienvenida).
  async function guardarConsentimiento(caja) {
    try {
      await actualizar({ attributes: { club_whatsapp: caja.checked ? 'si' : '' } });
    } catch {
      // Sin red el formulario nativo de la página de carrito sigue enviando
      // attributes[club_whatsapp] al finalizar; en el cajón no hay respaldo.
    }
  }

  // Miembros: aplica los códigos una vez por sesión de navegación. Si Shopify
  // no acepta la combinación (los códigos no son combinables entre sí), prueba
  // cada uno por separado y se queda con el primero que descuente algo.
  async function aplicarClub() {
    const dueno = $('[data-sg-club-codigos]');
    if (!dueno) return;
    const codigos = dueno.dataset.sgClubCodigos.split(',').map((c) => c.trim()).filter(Boolean);
    if (!codigos.length) return;
    let clave = 'sg-club-aplicado';
    try {
      if (sessionStorage.getItem(clave)) return;
    } catch {}
    try {
      const estado = await fetch(`${window.Shopify.routes.root}cart.js`).then((r) => r.json());
      if (!estado.item_count) return;
      if (estado.total_discount > 0) {
        sessionStorage.setItem(clave, '1');
        return;
      }
      let carrito = await actualizar({ discount: codigos.join(',') });
      if (!(carrito.total_discount > 0) && codigos.length > 1) {
        for (const c of codigos) {
          carrito = await actualizar({ discount: c });
          if (carrito.total_discount > 0) break;
        }
      }
      try {
        sessionStorage.setItem(clave, '1');
      } catch {}
      if (carrito.total_discount > 0) await refrescar();
    } catch {}
  }

  /* ---------------------------------------------------------------------- */
  /* Cantidades y eliminar                                                   */
  /* ---------------------------------------------------------------------- */

  let ocupado = false;

  async function cambiar(linea, cantidad) {
    // Dos clics seguidos en "+" mandarían dos peticiones con la misma cantidad
    // de partida, y la segunda pisaría a la primera.
    if (ocupado) return;
    ocupado = true;

    const c = cajon();
    const pag = $('[data-sg-cart-page]');
    c && c.setAttribute('aria-busy', 'true');
    pag && pag.setAttribute('aria-busy', 'true');

    try {
      await fetch(`${window.Shopify.routes.root}cart/change.js`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ line: linea, quantity: cantidad }),
      });
      await refrescar();
    } finally {
      ocupado = false;
      c && c.removeAttribute('aria-busy');
      pag && pag.removeAttribute('aria-busy');
    }
  }

  /* ---------------------------------------------------------------------- */

  function init() {
    document.addEventListener('submit', (e) => {
      const form = e.target.closest('[data-sg-add]');
      if (!form) return;
      e.preventDefault();
      agregar(form);
    });

    // La ficha de producto agrega por su cuenta (sg-producto.js, con sabor y
    // cantidad) y avisa con este evento; sin la escucha, el cajón se abría con
    // el marcado viejo y decía "tu carrito está vacío" con el producto ya
    // dentro, y el contador del header se quedaba en 0.
    document.addEventListener('sg:carrito-actualizado', () => refrescar());

    // Delegación en document: el marcado del cajón y el de la página se
    // reemplazan enteros al refrescar, así que enlazar elemento por elemento
    // obligaría a re-enlazar cada vez y duplicaría escuchas en lo que sobrevive.
    document.addEventListener('click', (e) => {
      if (e.target.closest('[data-sg-cart-open]')) {
        e.preventDefault();
        abrir();
      }
      if (e.target.closest('[data-sg-cart-close]') || e.target.closest('[data-sg-cart-overlay]')) {
        cerrar();
      }

      const paso = e.target.closest('[data-sg-qty]');
      if (paso) {
        e.preventDefault();
        cambiar(paso.dataset.linea, parseInt(paso.dataset.sgQty, 10));
        return;
      }

      const quitar = e.target.closest('[data-sg-remove]');
      if (quitar) {
        // Sin JavaScript esto es un enlace GET a cart/change que funciona igual.
        e.preventDefault();
        cambiar(quitar.dataset.linea, 0);
      }
    });

    // Club Savage: casilla, teléfono y códigos de miembro
    document.addEventListener('change', (e) => {
      const caja = e.target.closest('[data-sg-club-wa]');
      if (caja) guardarConsentimiento(caja);
    });
    document.addEventListener('sg:carrito-actualizado', () => aplicarClub());
    aplicarClub();

    // Escribir la cantidad a mano en la página de carrito
    document.addEventListener('change', (e) => {
      const input = e.target.closest('[data-sg-qty-input]');
      if (!input) return;
      const n = parseInt(input.value, 10);
      if (Number.isNaN(n) || n < 0) return;
      cambiar(input.dataset.linea, n);
    });

    // Enter dentro del campo de cantidad no debe enviar el formulario entero
    document.addEventListener('keydown', (e) => {
      if (e.key === 'Enter' && e.target.closest('[data-sg-qty-input]')) {
        e.preventDefault();
        e.target.blur();
      }
    });

    document.addEventListener('keydown', (e) => {
      const c = cajon();
      if (!c || c.dataset.open !== 'true') return;
      if (e.key === 'Escape') cerrar();
      if (e.key === 'Tab') {
        const f = $$('button, a[href], input', c).filter((el) => el.offsetParent !== null);
        if (!f.length) return;
        const [primero, ultimo] = [f[0], f[f.length - 1]];
        if (e.shiftKey && document.activeElement === primero) {
          e.preventDefault();
          ultimo.focus();
        } else if (!e.shiftKey && document.activeElement === ultimo) {
          e.preventDefault();
          primero.focus();
        }
      }
    });
  }

  document.readyState === 'loading'
    ? document.addEventListener('DOMContentLoaded', init)
    : init();
})();
